import { SortDirection } from './sort-direction.type';

export enum SortType {
  single = 'single',
  multi = 'multi'
}

export interface TableSort {
  dir: SortDirection;
  prop: string;
}

export interface TableSorts {
  sorts: Array<TableSort>;
}
